import { useMutation } from 'react-query'

import { ApproveExpenseUseCase } from '@webapp/modules/expense/business-logic/use-cases/ApproveExpenseUseCase'
import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'
import { settingsRepository } from '@webapp/platform/finance'

const approveExpenseUseCase = new ApproveExpenseUseCase({
  expenseRepository,
  settingsRepository,
})

interface ApproveExpensePayload {
  expenseId: number
  nextApproverId: Nullable<number>
  shouldSkipBudgetCheck?: boolean
}

export const useMutateApproveExpense = () => {
  const mutation = useMutation<void, Error, ApproveExpensePayload>({
    mutationFn: (payload) => approveExpenseUseCase.execute(payload),
  })

  return {
    mutate: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
